var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order
    ? _c(
        "div",
        { staticClass: "order-details-payment my-5 mr-10" },
        [
          _vm.order.payments.length <= 0
            ? _c("div", [
                _vm.order.Table == -18
                  ? _c(
                      "div",
                      {
                        class: {
                          "tagIcon-bo-s1": !_vm.white,
                          "tagIcon-white": _vm.white,
                          short: _vm.short,
                        },
                      },
                      [
                        _vm.order.Remain == 0
                          ? _c("i", {
                              staticClass: "icon-eatselfapp_smartphone",
                              attrs: { title: "Paiement borne" },
                            })
                          : _vm._e(),
                        !_vm.short && _vm.order.Remain == 0
                          ? _c("span", [_vm._v("Paiement borne")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.Remain != 0
                          ? _c("i", {
                              staticClass: "icon-eatselfapp_smartphone",
                              attrs: { title: "Aucun paiement" },
                            })
                          : _vm._e(),
                        !_vm.short && _vm.order.Remain != 0
                          ? _c("span", [_vm._v("Aucun paiement")])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.Table != -18
                  ? _c(
                      "div",
                      {
                        class: {
                          "tagIcon-bo-danger": !_vm.white,
                          "tagIcon-white": _vm.white,
                          short: _vm.short,
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fie-icon_error",
                          attrs: { title: "Erreur paiement" },
                        }),
                        !_vm.short
                          ? _c("span", [_vm._v("Erreur paiement")])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.validPayments, function (payment, i) {
            return _c("div", { key: i }, [
              payment.PaymentMethod == 1
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-p2": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "En caisse" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_cash-register" }),
                      !_vm.short ? _c("span", [_vm._v("En caisse")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              payment.PaymentMethod == 2
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-s1": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Carte bleue" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_credit-card" }),
                      !_vm.short
                        ? _c("span", [_vm._v("Carte bleue")])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              payment.PaymentMethod == 4
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-p1": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Fidélité" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_discount" }),
                      !_vm.short ? _c("span", [_vm._v("Fidélité")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              payment.PaymentMethod == 16
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-p1": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Wallet" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_ticket" }),
                      !_vm.short ? _c("span", [_vm._v("Wallet")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              payment.PaymentMethod == 8
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-s2": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Paygreen" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_ticket" }),
                      !_vm.short ? _c("span", [_vm._v("Paygreen")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              payment.PaymentMethod == 32
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-bo-s2": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Edenred" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_ticket" }),
                      !_vm.short ? _c("span", [_vm._v("Edenred")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              ![1, 2, 4, 8, 16, 32].includes(+payment.PaymentMethod)
                ? _c(
                    "div",
                    {
                      class: {
                        "tagIcon-blueD": !_vm.white,
                        "tagIcon-white": _vm.white,
                        short: _vm.short,
                      },
                      attrs: { title: "Autres" },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_ticket" }),
                      !_vm.short ? _c("span", [_vm._v("Autres")]) : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }